<div [ngClass]="alertType" class="alert-icon-panel">
  @if (alertType==='error') {
    <mat-icon>error</mat-icon>
  }
  @if (alertType==='info') {
    <mat-icon>info</mat-icon>
  }
  @if (alertType==='warn') {
    <mat-icon>warning</mat-icon>
  }
  @if (alertType==='success') {
    <mat-icon>done</mat-icon>
  }
</div>
<div class="alert-message-panel">{{alertMessage}}</div>
<div class="alert-action-panel">
  <button (click)="dismiss()" mat-icon-button title="Close alert">
    <mat-icon>close</mat-icon>
  </button>
</div>
